export default "__VITE_ASSET__NWXjlcU7__"